import { takeEvery, put, takeLatest, delay, select } from 'redux-saga/effects';
import Querystring from 'querystring';
import types from 'redux/types';
import hooks from 'hooks';
import Services, { HeaderUTF8Option } from 'services';
import UserServices from 'services/UserServices';
import {
  isResponseSuccess,
  cloneObjectByKeys,
  getFileName,
  isResponseURL,
  trimAllValuesInObject,
  isDefine,
} from 'helpers';
import {
  USER_SERVLET_URL,
  MANAGE_USERS_URL,
  ADMIN_SERVLET_URL,
  EXPORT_READFILE_URL,
  DELETE_DID_URL,
} from 'consts/api';
import cloneDeep from 'lodash/cloneDeep';
import { getManageUser } from './manageUserSaga';
import { TIME_OUT_CLOSE_TOAST } from 'consts/data';
import { showError } from 'helpers/handleError';
import { notifySuccess } from 'helpers/handleNotification';
import { get, isString, set } from 'lodash';
import ShortLinkTagsBuilderModel from 'models/shortlink-tags-builder.model';
import services from 'services';
import ClickFilterModel from 'models/click-filter-setting.model';

const moment = require('moment');
const fileDownload = require('js-file-download');

const { Notification } = hooks;

const {
  REQUEST_API_USERSERVLET,
  REQUEST_API_USERSERVLET_SUCCESS,
  REQUEST_API_USERSERVLET_FAILED,
  REQUEST_GET_LIST_USERS,
  REQUEST_GET_LIST_USERS_FAILED,
  REQUEST_GET_LIST_USERS_SUCCESS,
  REQUEST_DELETE_USERS,
  REQUEST_DELETE_USERS_FAILED,
  REQUEST_DELETE_USERS_SUCCESS,
  REQUEST_CREATE_USERS,
  REQUEST_CREATE_USERS_FAILED,
  REQUEST_CREATE_USERS_SUCCESS,
  REQUEST_ADD_DIDS,
  REQUEST_ADD_DIDS_FAILED,
  REQUEST_ADD_DIDS_SUCCESS,
  REQUEST_MIGRATE_DIDS,
  REQUEST_MIGRATE_DIDS_FAILED,
  REQUEST_MIGRATE_DIDS_SUCCESS,
  REQUEST_SHOW_DIDS,
  REQUEST_SHOW_DIDS_FAILED,
  REQUEST_SHOW_DIDS_SUCCESS,
  REQUEST_DELETE_VIRTUALPHONE,
  REQUEST_DELETE_VIRTUALPHONE_FAILED,
  REQUEST_DELETE_VIRTUALPHONE_SUCCESS,
  REQUEST_ADD_CREDITS_USER,
  REQUEST_ADD_CREDITS_USER_SUCCESS,
  REQUEST_ADD_CREDITS_USER_FAILED,
  REQUEST_UPDATE_USER,
  REQUEST_UPDATE_USER_FAILED,
  REQUEST_UPDATE_USER_SUCCESS,
  REQUEST_CLONE_USER,
  REQUEST_CLONE_USER_SUCCESS,
  REQUEST_CLONE_USER_FAILED,
  REQUEST_UPDATE_PROFILE,
  REQUEST_UPDATE_PROFILE_SUCCESS,
  REQUEST_UPDATE_PROFILE_FAILED,
  REQUEST_UPDATE_SETTING,
  REQUEST_UPDATE_SETTING_SUCCESS,
  REQUEST_UPDATE_SETTING_FAILED,
  REQUEST_UPDATE_SETTING_API,
  REQUEST_UPDATE_SETTING_API_FAILED,
  REQUEST_UPDATE_SETTING_API_SUCCESS,
  REQUEST_BACKUP_NOW,
  REQUEST_BACKUP_NOW_FAILED,
  REQUEST_BACKUP_NOW_SUCCESS,
  REQUEST_RESTORE,
  REQUEST_RESTORE_FAILED,
  REQUEST_RESTORE_SUCCESS,
  REQUEST_EXPORT_USER,
  REQUEST_EXPORT_USER_SUCCESS,
  REQUEST_EXPORT_USER_FAILED,
  REQUEST_EXPORT_CREDIT_STATUS,
  REQUEST_EXPORT_CREDIT_STATUS_FAILED,
  REQUEST_EXPORT_CAMPAIN,
  REQUEST_EXPORT_CAMPAIN_FAILED,
  REQUEST_UPDATE_REQUEST_CLICK,
  REQUEST_UPDATE_REQUEST_CLICK_SUCCESS,
  REQUEST_UPDATE_REQUEST_CLICK_FAILED,
} = types;

export function* getUserServlet() {
  try {
    const response = yield UserServices.getUserInfo();
    if (isResponseSuccess(response.status) && response.data) {
      if (typeof response.data === 'string' && response.data.toLowerCase() === 'fail') {
        yield put({ type: REQUEST_API_USERSERVLET_FAILED, error: 'FAIL' });
      } else {
        services.shouldCheckOriginEmail = true;

        const userResponse = { ...response.data, name: 'TB' };
        UserServices.updateCachedUser(userResponse);
        yield put({
          type: REQUEST_API_USERSERVLET_SUCCESS,
          payload: userResponse,
        });
      }
    }
  } catch (error) {
    yield put({ type: REQUEST_API_USERSERVLET_FAILED, error });
  }
}

function* getListUsers(data) {
  const {
    sortFields,
    sortDirections,
    pageSize,
    pageIndex,
    searchFilters,
    searchValues,
    operator,
    userStatuses,
  } = data;
  try {
    const filters = {
      sortDirections,
      searchValues,
      searchFilters: searchFilters,
      sortFields,
      operator: operator,
      pageSize,
      page: pageIndex + 1,
      userStatuses: (userStatuses || []).map((el) => el?.status).join(','),
    };
    const res = yield UserServices.getListUser({
      action: 'searchBySelectedField',
      filters,
    });

    if (res.data?.includes('null')) {
      yield put({
        type: REQUEST_GET_LIST_USERS_SUCCESS,
        data: [],
        total: 0,
      });
      return;
    }
    if (isResponseSuccess(res.status)) {
      if (res.data && typeof res.data === 'object') {
        const resTotal = yield UserServices.getTotalListUser({
          action: 'totalBySelectedField',
          filters,
        });
        if (isResponseSuccess(resTotal.status)) {
          yield put({
            type: REQUEST_GET_LIST_USERS_SUCCESS,
            data: res.data,
            total: resTotal.data,
          });
        }
      } else if (typeof res.data === 'string') {
        showError('Something wrong! Please report to us!');
        yield put({
          type: REQUEST_GET_LIST_USERS_FAILED,
          error: res.data.toString(),
        });
      }
    }
  } catch (error) {
    showError(error, error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_GET_LIST_USERS_FAILED, error });
  }
}

function* deleteUser(data) {
  data.action = 'deleteUsers';
  const { emails, action, setSubmitting, toggle, filters } = data;
  try {
    setSubmitting(true);
    const res = yield UserServices.deleteUser({ action, emails });
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message === 'success') {
          yield getListUsers(filters);
          setSubmitting(false);
          toggle();
          Notification('success', 'Deleted Successfully!', '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_DELETE_USERS_SUCCESS });
        } else {
          setSubmitting(false);
          toggle();
          showError(message, '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_DELETE_USERS_FAILED, error: message });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    toggle();
    showError(error);
    yield put({ type: REQUEST_DELETE_USERS_FAILED, error });
  }
}

function* createUser(data) {
  data.action = 'createUser';
  const { toggle, setSubmitting, action } = data;
  const dataClone = cloneDeep(data);

  dataClone.firstname = dataClone.firstname.trim();
  dataClone.lastname = dataClone.lastname.trim();
  dataClone.agentAcc = dataClone.agentAcc.trim();
  dataClone.email = dataClone.email?.trim();
  dataClone.genderName = data.gender === 'm' ? 'Male' : 'Female';

  delete dataClone.toggle;
  delete dataClone.setSubmitting;
  delete dataClone.type;
  delete dataClone.action;
  delete dataClone.filters;
  delete dataClone.gender;

  try {
    const res = yield UserServices.createUser({ action, dataUser: dataClone });
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message === 'success') {
          // Re-get list
          const resGetList = yield Services.post(
            MANAGE_USERS_URL,
            Querystring.stringify({
              action: 'search',
              'sortFields[]': 'createDate',
              'sortDirections[]': 'DESC',
              pageSize: 50,
              page: 1,
            })
          );
          if (isResponseSuccess(resGetList.status)) {
            if (resGetList && typeof resGetList.data === 'object') {
              const itemRecentCreated = resGetList.data[0];
              setSubmitting(false);
              toggle();
              Notification('success', 'Created Successfully!', '', TIME_OUT_CLOSE_TOAST);
              yield put({
                type: REQUEST_CREATE_USERS_SUCCESS,
                itemRecentCreated,
              });
            }
          }
        } else if (message === 'exist') {
          setSubmitting(false);
          showError('This email already exist. Please try again with another email.');
          yield put({ type: REQUEST_CREATE_USERS_FAILED, error: message });
        } else if (message === 'fail_no_agentmail') {
          setSubmitting(false);
          showError('The agent email is not exist. Please try again.');
          yield put({ type: REQUEST_CREATE_USERS_FAILED, error: message });
        } else {
          setSubmitting(false);
          showError('Cannot create user, please try again.');
          yield put({ type: REQUEST_CREATE_USERS_FAILED, error: message });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    showError(error, error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_CREATE_USERS_FAILED, error });
  }
}

function* showDids(data) {
  data.action = 'fetchPhoneNumbers';
  const { action, useremail, filters = {} } = data;
  const listDid = yield select((state) => state.userServletReducer.didInUser.listDid);
  try {
    const { offset = 0 } = filters;
    const res = yield UserServices.showDid({
      action,
      useremail,
      offset,
    });

    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'object') {
        yield put({
          type: REQUEST_SHOW_DIDS_SUCCESS,
          data: res.data,
        });
      } else {
        const message = res.data.toLowerCase();
        if (message === 'notexist') {
          if (listDid.length > 0) {
            yield put({
              type: REQUEST_SHOW_DIDS_SUCCESS,
              isLastItem: true,
            });
          } else {
            yield put({
              type: REQUEST_SHOW_DIDS_FAILED,
              error: 'No phone number was found for the selected user !',
            });
          }
        } else {
          showError(message);
          yield put({
            type: REQUEST_SHOW_DIDS_FAILED,
            error: message,
          });
        }
      }
    }
  } catch (error) {
    showError(error, error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_SHOW_DIDS_FAILED, error });
  }
}

function* addDids(data) {
  data.action = 'addVirtualPhone';
  const { action, phone, emailUser, phoneType: type, toggle, setSubmitting, filters } = data;
  try {
    setSubmitting(true);
    const res = yield Services.post(
      ADMIN_SERVLET_URL,
      Querystring.stringify({
        action,
        phone,
        type,
        emailUser,
      })
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        // Re-get show dids
        yield showDids({
          action: 'fetchPhoneNumbers',
          filters,
          useremail: emailUser,
        });

        if (res.data.toLowerCase().includes('successfully')) {
          yield put({ type: REQUEST_ADD_DIDS_SUCCESS });
          Notification('success', 'Created Successfully!', '', TIME_OUT_CLOSE_TOAST);
          setSubmitting(false);
          toggle();
          // End Re-get
        } else {
          setSubmitting(false);
          showError(res.data);
          yield put({
            type: REQUEST_ADD_DIDS_FAILED,
            error: res.data,
          });
        }
      } else {
        setSubmitting(false);
        showError(res.data.toString());
        yield put({
          type: REQUEST_ADD_DIDS_FAILED,
          error: res.data.toString(),
        });
      }
    }
  } catch (error) {
    setSubmitting(false);
    showError(error, error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_ADD_DIDS_FAILED, error });
  }
}

function* migrateDids(data) {
  data.action = 'migrateVirtualPhone';
  const {
    action,
    numberOfPhone,
    phoneType,
    toEmailUser,
    fromEmailUser,
    chargeFee,
    toggle,
    setSubmitting,
  } = data;
  try {
    setSubmitting(true);
    const res = yield Services.post(
      ADMIN_SERVLET_URL,
      Querystring.stringify({
        action,
        numberOfPhone,
        phoneType,
        toEmailUser,
        fromEmailUser,
        chargeFee,
      })
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        if (res.data.toLowerCase().includes('successfully')) {
          toggle();
          setSubmitting(false);
          Notification('success', 'Migrated Successfully!', '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_MIGRATE_DIDS_SUCCESS });
        } else {
          setSubmitting(false);
          showError(res.data);
          yield put({
            type: REQUEST_MIGRATE_DIDS_FAILED,
            error: res.data,
          });
        }
      } else {
        setSubmitting(false);
        showError(res.data.toString());
        yield put({
          type: REQUEST_MIGRATE_DIDS_FAILED,
          error: res.data.toString(),
        });
      }
    }
  } catch (error) {
    setSubmitting(false);
    showError(error);
    yield put({ type: REQUEST_MIGRATE_DIDS_FAILED, error });
  }
}

function* deleteVirtualPhone(data) {
  const { phone, toggle, setSubmitting } = data;
  try {
    setSubmitting(true);
    const res = yield Services.post(DELETE_DID_URL, {
      phone,
    });
    if (isResponseSuccess(res.status)) {
      toggle();
      setSubmitting(false);
      Notification('success', 'Deleted Successfully!', '', TIME_OUT_CLOSE_TOAST);
      yield put({ type: REQUEST_DELETE_VIRTUALPHONE_SUCCESS, phone: phone });
    }
  } catch (error) {
    setSubmitting(false);
    showError(error, error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_DELETE_VIRTUALPHONE_FAILED, error });
  }
}

function* updateUser(data) {
  data.action = 'updateUserInfo';
  const {
    isEditItSelf,
    action,
    setSubmitting,
    filters,
    email,
    firstname,
    lastname,
    phoneType,
    speed,
    statusName,
    role,
    address1,
    address2,
    city,
    state,
    timeName,
    zip,
    gender,
    phone,
    referrerId,
    company,
    companyDesc,
    companyPhone,
    industry,
    opHours,
    apiRequestKey,
    note,
    linkAccountUser,
    showCreditUser,
    showBTEmailUser,
    activateCreditPooling,
    enableCreditPooling,
    useAgencyCredit,
    hasActivatedEmailLink,
    hasActivatedText,
    country,
    twoWay,
    agentAcc,
    enableAutoScrub,
    skipScrubDNC,
    skipScrubLandline,
    enableDummyCampaign,
    liveFeedForward,
    limitNumberMessagePerDay,
    failoverRouteEnable,
    failoverRouteId,
    dataConsumerEnabled,
  } = data;

  try {
    const res = yield Services.post(
      MANAGE_USERS_URL,
      Querystring.stringify({
        action,
        email: email?.trim(),
        firstname: firstname?.trim(),
        lastname: lastname?.trim(),
        phone,
        speed,
        isDelPhone: false,
        statusName,
        role,
        address1,
        address2,
        city,
        state,
        timeName,
        zip,
        country,
        genderName: gender === 'm' ? 'Male' : 'Female',
        referrerId,
        phoneType,
        company,
        companyDesc,
        companyPhone,
        industry,
        opHours,
        apiKey: apiRequestKey,
        note,
        linkAccountUser,
        showCreditUser,
        showBTEmailUser,
        activateCreditPooling,
        enableCreditPooling,
        useAgencyCredit,
        hasActivatedEmailLink,
        hasActivatedText,
        twoWay,
        enableAutoScrub,
        skipScrubDNC,
        skipScrubLandline,
        enableDummyCampaign,
        liveFeedForward,
        agentAcc: agentAcc ? agentAcc.trim() : agentAcc,
        limitNumberMessagePerDay,
        // linkedAgencyForCreditPooling: ? string: ?
        failoverRouteEnable,
        failoverRouteId,
        dataConsumerEnabled,
      }),
      HeaderUTF8Option
    );
    if (isResponseSuccess(res.status)) {
      if (res.data['RESPONSE']) {
        if (res.data['RESPONSE'] === 'FAIL') {
          setSubmitting(false);
          showError(res.data['REASON']);
          yield put({
            type: REQUEST_UPDATE_USER_FAILED,
            error: res.data['REASON'],
          });
        }
      }
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message === 'success') {
          yield getListUsers(filters);
          setSubmitting(false);
          Notification('success', 'Updated Successfully', '', TIME_OUT_CLOSE_TOAST);

          if (isEditItSelf) {
            yield getUserServlet();
          }
          yield put({ type: REQUEST_UPDATE_USER_SUCCESS });
        } else {
          setSubmitting(false);
          showError(message);
          yield put({ type: REQUEST_UPDATE_USER_FAILED, error: message });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    showError(error);
    yield put({ type: REQUEST_UPDATE_USER_FAILED, error });
  }
}

function* addCredit(data) {
  data.action = 'sendUserBonusTexts';
  const { useremail, _type: type, noOfTexts, setSubmitting, toggle, action, filters } = data;
  try {
    const res = yield UserServices.addCredit({
      action,
      useremail,
      type,
      noOfTexts,
    });
    if (isResponseSuccess(res.status)) {
      if (res.data && typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message === 'success') {
          // Update credit of account which logging in
          yield getListUsers(filters);
          toggle();
          setSubmitting(false);
          Notification('success', 'Added Credit Successfully!', '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_ADD_CREDITS_USER_SUCCESS });
        } else {
          setSubmitting(false);
          showError(message);
          yield put({ type: REQUEST_ADD_CREDITS_USER_FAILED, error: message });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    showError(error);
    yield put({ type: REQUEST_ADD_CREDITS_USER_FAILED, error });
  }
}

function* cloneUser(data) {
  data.action = 'cloneUser';
  const { setSubmitting, toggle, filters, action } = data;
  try {
    setSubmitting(true);
    const res = yield UserServices.cloneUser({ dataUser: data, action });
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message === 'success') {
          yield getListUsers(filters);
          setSubmitting(false);
          Notification('success', 'Cloned Successfully!', '', TIME_OUT_CLOSE_TOAST);
          toggle();
          yield put({ type: REQUEST_CLONE_USER_SUCCESS });
        } else if (message === 'exist') {
          setSubmitting(false);
          showError('Email input is existed! Please try again with other email!');
          yield put({ type: REQUEST_CLONE_USER_FAILED, error: message });
        } else {
          setSubmitting(false);
          showError(message);
          yield put({ type: REQUEST_CLONE_USER_FAILED, error: message });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    showError(error);
    yield put({ type: REQUEST_CLONE_USER_FAILED, error });
  }
}

function* updateProfile(data) {
  data.action = 'update';
  const { callbacks } = data;
  const { onSuccess, onFailed } = callbacks || {};

  const dataPost = cloneObjectByKeys(
    [
      'action',
      'myAccountPhone',
      'myAccountFirstname',
      'myAccountLastname',
      'myAccountGender',
      'myAccountAddress1',
      'myAccountAddress2',
      'myAccountCity',
      'myAccountState',
      'myAccountZip',
      'myAccountTxn',
      'myAccountCompany',
      'myAccountCompanyDesc',
      'myAccountCompanyPhone',
      'myAccountIndustry',
      'myAccountNoCustomers',

      //* Billing
      'myBillingAddress',
      'myBillingName',
      'myBillingCountry',
      'myBillingRegNo',
      'myBillingVatNo',
      'myBillingIBAN',
      'myBillingBIC',
      'myBillingIntermediaryBIC',
      'myBillingBank',
      'myBillingBankAddress',
      'myEntityName',
    ],
    data
  );
  try {
    const res = yield Services.post(
      USER_SERVLET_URL,
      Querystring.stringify(trimAllValuesInObject(dataPost)),
      HeaderUTF8Option
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message === 'success') {
          yield getUserServlet();
          Notification('success', 'Updated Successfully!', '', TIME_OUT_CLOSE_TOAST);
          onSuccess && onSuccess();
          yield put({ type: REQUEST_UPDATE_PROFILE_SUCCESS });
        } else {
          showError(message);
          onFailed && onFailed(message);
          yield put({ type: REQUEST_UPDATE_PROFILE_FAILED, error: message });
        }
      }
    }
  } catch (error) {
    onFailed && onFailed(error);
    showError(error);
    yield put({ type: REQUEST_UPDATE_PROFILE_FAILED, error });
  }
}

function* updateSettings(data) {
  data.action = 'updateSettings';
  const { setSubmitting, callbacks } = data;
  const dataPost = cloneObjectByKeys(
    [
      'action',
      'useAgencyCredit',
      'enableCreditPooling',
      'deleteInboxThreadForOptOuts',
      'chkSleepTimer',
      'startSleepTime',
      'endSleepTime',
      'chkIncomingNoti',
      'chkEmailIncomingNoti',
      'chkEmailSSL',
      'sendMailBy',
      'smtpServerName',
      'smtpFullName',
      'smtpFrom',
      'smtpUserName',
      'smtpServerPass',
      'toEmails',
      'sendEmailHour',
      'chkSMSIncomingNoti',
      // 'chkDontShowInbox',
      'notifPhone',
      'notifSendBy',
      'chkDailyBk',
      'statsForResponders',
      'sharedOptoutDup',
      'globalAccuracy',
      'myAccountSlackURL',
      'zendeskURL',
      'zendeskUN',
      'zendeskPW',
      'zendeskAll',
      'zendeskCreate',
      'contactTimezone',
      'archiveInboxDay',
      'archiveInboxMsgCount',
      'isArchiveInboxDay',
      'isArchiveInboxMsgCount',
      'prefillOfferConfig',
      'inputDomain',
      'prefillOfferEnable',
      'fullfillOfferEnable',
      'fullfillOfferConfig',

      'balanceNotiEmail',
      'balanceNotiPublish',
      'campaignNotiEmail',
      'campaignNotiPublish',
      'importContactNotiEmail',
      'importContactNotiPublish',
      'priceChangeNotiEmail',
      'priceChangeNotiPublish',
      'scrubNotiEmail',
      'scrubNotiPublish',
      'transactionNotiEmail',
      'transactionNotiPublish',
      'seedNumber',
      'seedEnabled',
      'notiEmailAddress',

      //* TA-601
      'domainNotiPublish',
      'domainNotiEmail',

      'ticketUpdateNotiEmail',
      'ticketUpdateNotiPublish',

      'domainInactiveNotiPublish',
      'domainInactiveNotiEmail',

      'fullfillImpressionConfig',
      'sleepWeekDays',
      'altSipServer',
      'shortlinkTagSetting',
      'enableMultipleLayerOffer',
    ],
    data
  );

  if (data?.autoOptimization) {
    dataPost.autoOpLap2Active = dataPost?.autoOpActive ? dataPost?.autoOpLap2Active : false;
    // Mapping body in Form -> body request
    // [field -> field in body]
    [
      //* LAP 1
      ['autoOp', 'autoOpActive'],
      ['testSize', 'autoOpTestSizeLap1'],
      ['pausedMin', 'autoOpPausedMinLap1'],

      ['threshold', 'autoOpThresholdLap1'],
      ['thresholdPerReply', 'autoOpThresholdPerReplyLap1'],
      ['thresholdPerBlock', 'autoOpThresholdPerBlockLap1'],
      ['thresholdPerOptout', 'autoOpThresholdPerOptoutLap1'],
      ['thresholdPerConvertor', 'autoOpThresholdPerConvertorLap1'],

      ['thresholdRevenuePerMilMessage', 'autoOpThresholdRevenuePerMilMessage'],
      ['thresholdRevenuePerMilMinute', 'autoOpThresholdRevenuePerMilMinute'],
      ['thresholdRevenuePerDeliveredCall', 'autoOpThresholdRevenuePerDeliveredCall'],
      ['thresholdCallRate', 'autoOpThresholdCallRate'],
      ['thresholdRoi', 'autoOpThresholdRoi'],

      //* LAP 2
      ['autoOpLap2', 'autoOpLap2Active'],
      ['autoOpLap2CreativeSize', 'autoOpLap2CreativeSize'],
      ['testSizeLap2', 'autoOpTestSizeLap2'],
      ['pausedMinLap2', 'autoOpPausedMinLap2'],

      ['thresholdLap2', 'autoOpThresholdLap2'],
      ['thresholdPerReplyLap2', 'autoOpThresholdPerReplyLap2'],
      ['thresholdPerBlockLap2', 'autoOpThresholdPerBlockLap2'],
      ['thresholdPerOptoutLap2', 'autoOpThresholdPerOptoutLap2'],
      ['thresholdPerConvertor2', 'autoOpThresholdPerConvertorLap2'],

      ['thresholdRevenuePerMilMessageLap2', 'autoOpThresholdRevenuePerMilMessageLap2'],
      ['thresholdRevenuePerMilMinuteLap2', 'autoOpThresholdRevenuePerMilMinuteLap2'],
      ['thresholdRevenuePerDeliveredCallLap2', 'autoOpThresholdRevenuePerDeliveredCallLap2'],
      ['thresholdCallRateLap2', 'autoOpThresholdCallRateLap2'],
      ['thresholdRoiLap2', 'autoOpThresholdRoiLap2'],
    ].forEach(([nameField, nameFieldToBody]) => {
      set(dataPost, nameFieldToBody, get(data, `autoOptimization.${nameField}`));
    });
  }

  dataPost.fullfillOfferConfig = dataPost.fullfillOfferConfig.replace('?', '');
  dataPost.notiEmailAddress = (dataPost?.notiEmailAddress || '').trim();
  dataPost.fullfillImpressionConfig = dataPost?.fullfillImpressionConfig.replace('?', '');

  dataPost.prefillOfferConfig = `${dataPost?.inputDomain}?${dataPost?.prefillOfferConfig}`;
  dataPost.seedNumber = isString(dataPost?.seedNumber)
    ? dataPost?.seedNumber
        .trim()
        .split(',')
        .filter((el) => !!el)
        .map((el) => el.replaceAll(' ', ''))
        .join(',')
    : '';
  dataPost.sleepWeekDays = JSON.stringify(dataPost?.sleepWeekDays || []);
  dataPost.altSipServer = isDefine(dataPost?.altSipServer)
    ? dataPost?.altSipServer
        .split(',')
        .map((el) => el?.trim())
        .join(',')
    : '';

  const { subDomainParts, pathParts } = ShortLinkTagsBuilderModel.parseShortLinkTagsToRequestBody(
    get(dataPost, 'shortlinkTagSetting.shortLinkTags') || []
  );
  dataPost.shortlinkTagSetting = JSON.stringify({
    enabled: get(dataPost, 'shortlinkTagSetting.enabled'),
    subDomainParts,
    pathParts,
  });

  try {
    const res = yield UserServices.updateSetting(dataPost);
    if (isResponseSuccess(res.status)) {
      const message = res.data.toLowerCase();
      if (message.includes('successfully')) {
        yield getUserServlet();
        notifySuccess(res.data, undefined, undefined, 5000);
        setSubmitting(false);
        yield put({ type: REQUEST_UPDATE_SETTING_SUCCESS });
        callbacks && callbacks.onSuccess();
      } else {
        setSubmitting(false);
        showError(message);
        yield put({ type: REQUEST_UPDATE_SETTING_FAILED, error: message });
      }
    }
  } catch (error) {
    setSubmitting(false);
    showError(error);
    yield put({ type: REQUEST_UPDATE_SETTING_FAILED, error });
  }
}

function* updateSettingsAPI(data) {
  data.action = 'updateApiSetting';
  const { setSubmitting } = data;
  const dataPost = cloneObjectByKeys(
    ['action', 'apiPostback', 'globalIncomingUrl', 'globalIncomingMethod', 'checkAPIMode'],
    data
  );
  try {
    setSubmitting(true);
    const res = yield Services.post(
      USER_SERVLET_URL,
      Querystring.stringify(trimAllValuesInObject(dataPost)),
      HeaderUTF8Option
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message.includes('successfully')) {
          yield getUserServlet();
          setSubmitting(false);
          Notification('success', 'Updated Successfully', '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_UPDATE_SETTING_API_SUCCESS });
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    showError(error);
    yield put({ type: REQUEST_UPDATE_SETTING_API_FAILED, error });
  }
}

function* backup(data) {
  data.action = 'updateSettings';
  try {
    const dataPost = cloneObjectByKeys(
      [
        'action',
        'archiveInboxDay',
        'archiveInboxMsgCount',
        'isArchiveInboxDay',
        'isArchiveInboxMsgCount',
      ],
      data
    );
    const res = yield Services.post(USER_SERVLET_URL, Querystring.stringify(dataPost));
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string' && res.data.includes('successfully')) {
        const backupRes = yield Services.post(
          USER_SERVLET_URL,
          Querystring.stringify({
            action: 'backupNow',
          })
        );
        if (isResponseSuccess(backupRes.status)) {
          if (typeof backupRes.data === 'string') {
            Notification('success', 'Backed up successfully', '', TIME_OUT_CLOSE_TOAST);
            yield put({ type: REQUEST_BACKUP_NOW_SUCCESS });
          }
        }
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_BACKUP_NOW_FAILED, error });
  }
}

function* restore(data) {
  data.action = 'doRestore';
  const { fileName, isRestoreContact, isRestoreData, isRestoreDelete, action } = data;
  try {
    const res = yield Services.post(
      USER_SERVLET_URL,
      Querystring.stringify({
        action,
        fileName,
        isRestoreContact,
        isRestoreData,
        isRestoreDelete,
      })
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string' && res.data.toLowerCase().includes('successfully')) {
        yield getUserServlet();
        Notification('success', 'Restored successfully!', '', TIME_OUT_CLOSE_TOAST);
        yield put({ type: REQUEST_RESTORE_SUCCESS });
      } else {
        showError('Something went wrong');
        yield put({
          type: REQUEST_RESTORE_FAILED,
          error: 'Something went wrong',
        });
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_RESTORE_FAILED, error });
  }
}

function* checkingExport(successCallback = () => {}, errorCallback = () => {}) {
  try {
    const response = yield Services.post(
      MANAGE_USERS_URL,
      Querystring.stringify({
        action: 'checkExport',
      })
    );
    if (isResponseSuccess(response.status)) {
      if (typeof response.data === 'string') {
        if (response.data.toLowerCase() === 'running') {
          yield delay(1500);
          yield checkingExport(successCallback, errorCallback);
        } else {
          yield put({ type: REQUEST_EXPORT_USER_SUCCESS });
          if (isResponseURL(response.data)) {
            const getFileCSV = yield Services.get(`${EXPORT_READFILE_URL}?file=${response.data}`);
            if (isResponseSuccess(getFileCSV.status)) {
              if (getFileCSV.data && typeof getFileCSV.data === 'string') {
                const fileName = getFileName(getFileCSV);
                fileDownload(getFileCSV.data, fileName);
                successCallback();
              } else {
                errorCallback();
                showError('Something was wrong! Please try again!');
              }
            }
          }
        }
      }
    }
  } catch (error) {
    showError(error);
    yield put({ type: REQUEST_EXPORT_USER_FAILED, error });
  }
}

function* exportUser(data) {
  data.action = 'export';
  try {
    const { isSelectAll, exceptUsername, onlyUsernames, action } = data;
    const body = isSelectAll
      ? Querystring.stringify({
          action,
          isSelectAll,
          exceptUsername,
        })
      : Querystring.stringify({
          action,
          isSelectAll,
          exceptUsername,
          onlyUsernames,
        });
    const res = yield Services.post(MANAGE_USERS_URL, body, HeaderUTF8Option);
    if (isResponseSuccess(res.status)) {
      yield checkingExport();
    }
  } catch (error) {
    showError(error, error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_EXPORT_USER_FAILED, error });
  }
}

function* exportCreditStatus(data) {
  data.action = 'statsexport';
  const { action, setSubmitting, fromDate, toDate, onlyUsernames, exceptUsername } = data;
  try {
    setSubmitting(true);
    const res = yield Services.post(
      MANAGE_USERS_URL,
      Querystring.stringify({
        action,
        fromDate: moment(fromDate).format('MM/DD/YYYY'),
        toDate: moment(toDate).format('MM/DD/YYYY'),
        exceptUsername,
        onlyUsernames,
      }),
      HeaderUTF8Option
    );

    if (isResponseSuccess(res.status)) {
      if (res.status) {
        if (typeof res.data === 'string') {
          if (res.data === 'FAIL') {
            setSubmitting(false);
            showError(res.data);
            yield put({
              type: REQUEST_EXPORT_CREDIT_STATUS_FAILED,
              error: res.data,
            });
          } else {
            // TODO: DO AFTER CLOUDTEXTBACK AI RUN
          }
        }
      }
    }
  } catch (error) {
    showError(error, error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_EXPORT_CREDIT_STATUS_FAILED, error });
  }
}

function* exportCampaignStats(data) {
  data.action = 'campaignexport';
  const { action, exceptUsername, onlyUsernames, lastSentDate, setSubmitting, toggle } = data;
  try {
    const res = yield Services.post(
      ADMIN_SERVLET_URL,
      Querystring.stringify({
        action,
        exceptUsername,
        onlyUsernames,
        lastSentDate: moment(lastSentDate).format('MM/DD/YYYY'),
      }),
      HeaderUTF8Option
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        if (res.data.includes('successfully')) {
          yield checkingExport(() => {
            setSubmitting(false);
            toggle();
          });
        } else {
          setSubmitting(false);
          Notification('info', res.data, '', TIME_OUT_CLOSE_TOAST);
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    showError(error, error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_EXPORT_CAMPAIN_FAILED, error });
  }
}

function* regenerateAPIKey(data) {
  const { useremail, callbacks } = data;
  try {
    const response = yield UserServices.regenerateApiKey(useremail);
    const userResponse = response?.data;
    yield put({
      type: types.REQUEST_REGENERATE_API_KEY_SUCCESS,
      payload: { userResponse, email: useremail },
    });
    notifySuccess('Regenertate API Key successfully!', 'Success');
    callbacks && callbacks.onSuccess();
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_REGENERATE_API_KEY_FAILED, error });
  }
}

function* updateRequestClick(data) {
  const { setSubmitting, resetForm, clickFilterSetting } = data;

  try {
    setSubmitting(true);
    const res = yield UserServices.updateClickFilter(
      ClickFilterModel.parseBodyToRequest(clickFilterSetting)
    );
    if (isResponseSuccess(res.status)) {
      if (typeof res.data === 'string') {
        const message = res.data.toLowerCase();
        if (message.includes('successfully')) {
          yield getUserServlet();
          setSubmitting(false);
          resetForm();
          Notification('success', 'Updated Successfully', '', TIME_OUT_CLOSE_TOAST);
          yield put({ type: REQUEST_UPDATE_REQUEST_CLICK_SUCCESS });
        } else {
          showError(res.data);
          setSubmitting(false);
        }
      }
    }
  } catch (error) {
    setSubmitting(false);
    showError(error, error.toString(), '', TIME_OUT_CLOSE_TOAST);
    yield put({ type: REQUEST_UPDATE_REQUEST_CLICK_FAILED, error });
  }
}

function* saveLayoutMonitoring(data) {
  const { nextColumns, callbacks } = data;
  try {
    yield UserServices.changeLayoutMonitoring(nextColumns);
    yield put({ type: types.REQUEST_SAVE_LAYOUT_MONITORING_SUCCESS, nextColumns });
    callbacks && callbacks.onSuccess();
  } catch (error) {
    yield put({ type: types.REQUEST_SAVE_LAYOUT_MONITORING_FAILED, error });
    callbacks && callbacks.onFailed(error);
  }
}

function* saveLayoutContact(data) {
  const { nextColumns, callbacks } = data;
  try {
    yield UserServices.updateContactLayout({ contactGroupLayout: nextColumns });
    yield put({ type: types.REQUEST_SAVE_LAYOUT_CONTACT_SUCCESS, nextColumns });
    callbacks && callbacks.onSuccess();
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_SAVE_LAYOUT_CONTACT_FAILED, error });
    callbacks && callbacks.onFailed(error);
  }
}

export default function* watchGetAPIFunction() {
  yield takeEvery(REQUEST_API_USERSERVLET, getUserServlet);
  yield takeLatest(REQUEST_GET_LIST_USERS, getListUsers);
  yield takeLatest(REQUEST_DELETE_USERS, deleteUser);
  yield takeLatest(REQUEST_CREATE_USERS, createUser);
  yield takeLatest(REQUEST_SHOW_DIDS, showDids);
  yield takeLatest(REQUEST_ADD_DIDS, addDids);
  yield takeLatest(REQUEST_MIGRATE_DIDS, migrateDids);
  yield takeLatest(REQUEST_DELETE_VIRTUALPHONE, deleteVirtualPhone);
  yield takeLatest(REQUEST_ADD_CREDITS_USER, addCredit);
  yield takeLatest(REQUEST_UPDATE_USER, updateUser);
  yield takeLatest(REQUEST_CLONE_USER, cloneUser);
  yield takeLatest(REQUEST_UPDATE_PROFILE, updateProfile);
  yield takeLatest(REQUEST_UPDATE_SETTING, updateSettings);
  yield takeLatest(REQUEST_UPDATE_SETTING_API, updateSettingsAPI);
  yield takeLatest(REQUEST_UPDATE_REQUEST_CLICK, updateRequestClick);
  yield takeLatest(REQUEST_BACKUP_NOW, backup);
  yield takeLatest(REQUEST_RESTORE, restore);
  yield takeLatest(REQUEST_EXPORT_USER, exportUser);
  yield takeLatest(REQUEST_EXPORT_CREDIT_STATUS, exportCreditStatus);
  yield takeLatest(REQUEST_EXPORT_CAMPAIN, exportCampaignStats);
  yield takeLatest(types.REQUEST_REGENERATE_API_KEY, regenerateAPIKey);
  yield takeLatest(types.REQUEST_SAVE_LAYOUT_MONITORING, saveLayoutMonitoring);
  yield takeLatest(types.REQUEST_SAVE_LAYOUT_CONTACT, saveLayoutContact);

  // Update switch user box
  yield takeLatest(REQUEST_CREATE_USERS_SUCCESS, getManageUser);
  yield takeLatest(REQUEST_DELETE_USERS_SUCCESS, getManageUser);
  yield takeLatest(REQUEST_CLONE_USER_SUCCESS, getManageUser);
}
